import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import portalService from '../services/portalService';
import localStorageService from '../services/localStorageService';
import { Modal, Button  } from 'react-bootstrap';
import { FaFileExcel } from "react-icons/fa";
import { toast, ToastContainer } from 'react-toastify';

import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { GetSpaceContext } from '../GetSpaceContext';
import './Orders.css';
import { Paginator } from './shared/Paginator';

import {dateValueFormatter, dateComparator} from '../utils/ag-grid-utils';
import CustomHeader from './shared/CustomHeader';

ModuleRegistry.registerModules([AllCommunityModule]);

const Orders = () => {
    const CustomButtonComponent = (props) => {
        console.log("Custom btn", props);
        return <button
            className="btn btn-danger btn-sm"
            onClick={() => {handleShowModal({id: props.data.id, sub: props.data.userSub})}}
        >Отменить бронь!</button>
    };

    const users = useContext(GetSpaceContext);
    const gridRef = useRef(null);
    const [orders, setOrders] = useState([]);
    const [items, setItems] = useState(null);
    const [locations, setLocations] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({ id: "", sub: "" });

    const [selectedBookingType, setSelectedBookingType] = useState('active');

    const pagination = true;
    const paginationPageSize = 50;
    const paginationPageSizeSelector = [50, 100, 150];

    const onBtnExport = useCallback(() => {
        gridRef.current.api.exportDataAsCsv();
    }, []);

    const handleSelect = (value) => {
        setSelectedBookingType(value);
    };

    const orderTypesGroup = () => {
        return (
            <div className="btn-group" role="group" aria-label="Toggle button group">
              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="btnradio1"
                autoComplete="off"
                checked={selectedBookingType === 'active'}
                onChange={() => handleSelect('active')}
              />
              <label className="btn btn-outline-primary" htmlFor="btnradio1">Активные</label>
        
              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id="btnradio2"
                autoComplete="off"
                checked={selectedBookingType === 'guest'}
                onChange={() => handleSelect('guest')}
              />
              <label className="btn btn-outline-primary" htmlFor="btnradio2">Гостевые</label>
            </div>
          );
    }

    const getItem = (itemId) => {
        return items[itemId];
    }

    const getTotalPrice = (order) => {
        const schedule = getItem(order.storageItemId).schedules.filter(s => s.id == order.scheduleId)[0];
        return schedule.price * schedule.schedule.monthCount;
    }

    const orderSeverity = (order) => {
        let now = new Date();
        if (order.expiry < Math.floor(now.getTime() / 1000) && order.bookingState === 1 && order.bookingType !== 0) {
            // Order is expired and active
            return 2;
        }
        let tomorrow = new Date(now);
        // Set to tomorrow
        tomorrow.setDate(now.getDate() + 1);

        // Set to 23:59:00
        tomorrow.setHours(23, 59, 0, 0);

        if (order.expiry > Math.floor(now.getTime() / 1000) && order.expiry < Math.floor(tomorrow.getTime() / 1000) && order.bookingState === 1 && order.bookingType !== 0) {
            // Order expires tomorrow
            return 1;
        }

        return 0;
    }

    const getOrderClass = (orderSeverity) => {
        switch (orderSeverity) {
            case 2:
                return 'order-expired';
            case 1:
                return 'order-expiring';
            default:
                return '';
        }
    }

    // disable sorting on all columns
    const defaultColDef = useMemo(() => { 
        return {
            sortable: true,
            filter: true,
            floatingFilter: true
        };
    }, []);

    // AG Grid
    const colDefs = useMemo(() => [
        {valueGetter: b => getOrderState(b.data.bookingState), headerName: "Состояние брони"},
        {valueFormatter: b => dateValueFormatter(b.data.dateUpdatedUnix),
            comparator: dateComparator,
            field: "dateUpdatedUnix",
            headerName:"Дата изменения",
        },
        {valueFormatter: b => dateValueFormatter(b.data.dateAddedUnix),
            comparator: dateComparator,
            field: "dateAddedUnix",
            headerName:"Дата начала брони",
        },
        {valueFormatter: b => dateValueFormatter(b.data.expiry),
            comparator: dateComparator,
            field: "expiry",
            headerName: "Срок завершения",
        },
        {field: "id", headerName: "Номер брони"},
        
        
        {field: "duration", headerName: "Длительность"},
        {field: "boxDisplay", headerName: "Номер ячейки", filter: true},
        
        {field: "totalPrice", headerName: "Сумма", valueFormatter: p => '₸' + p.value.toLocaleString()},
        
        
        //{field: "previousTransactionId"},
        
        {field: "location", headerName: "Локация", filter: true},
        //{field: "storageLocationId"},
        {field: "iin", headerName: "ИИН пользователя"},
        {field: "phoneNumber", headerName: "Телефон пользователя"},
        {valueGetter: b => getOrderType(b.data.bookingType), headerName: "Тип брони"},
        //{field: "transactionDate"},
        //{field: "transactionId"},
        //{field: "userSub"},
        {field: 'deleteBtn', headerName: '',
            cellRenderer: CustomButtonComponent
        }
    ], []);

    const postSortRows = params => {
        let rowNodes = params.nodes;
        let nextInsertPos = 0;
        for (let i = 0; i < rowNodes.length; i++) {
            const severity = rowNodes[i].data.severity;
            if (severity > 0) {
                rowNodes.splice(nextInsertPos, 0, rowNodes.splice(i, 1)[0]);
                nextInsertPos++;
            }
        }
    }

    // Filters


    const fetchTotalCount = async(abortController) => {
        const allItems = localStorageService.items.get();
        const allLocations = localStorageService.locations.get();
        console.log("All items", allItems);
        console.log("All locations", allLocations);
        setItems(allItems);
        setLocations(allLocations);
    }

    useEffect(() => {
        console.log("UseEffect for total count");
        const abortController = new AbortController();
        fetchTotalCount(abortController);
        return () => { abortController.abort(); }
    }, [selectedBookingType]);

    useEffect(() => {
        console.log("UseEffect for page change");
        console.log("Rendering Orders on page change");
        if (items) {
            const abortController = new AbortController();
            fetchOrders(abortController);
            return () => abortController.abort();
        }
    }, [items]); 

    // useEffect(() => {
    //     console.log("Current sorted column", sortedColumn);
    //     const abortController = new AbortController();
    //     fetchTotalCount(abortController);
    //     return () => { abortController.abort(); }
    // }, [sortedColumn]);
    
    const enrichOrders = (orders) => {
        return orders.map(order => {
            return {
                ...order,
                boxDisplay: getItem(order.storageItemId).boxCode + getItem(order.storageItemId).boxNum,
                duration: getItem(order.storageItemId).schedules.filter(s => s.id == order.scheduleId)[0].schedule.displayName,
                location: locations[order.storageLocationId].name,
                phoneNumber: users.filter(u => u.sub == order.userSub)[0].phoneNumber,
                iin: users.filter(u => u.sub == order.userSub)[0].iin,
                totalPrice: getTotalPrice(order),
                severity: orderSeverity(order)
            }
        })
    };

    const fetchOrders = async (controller) => {
        console.log("Fetching orders");
        let orders = await portalService.getOrders(selectedBookingType == "active", controller);
        if (orders && orders.data) {
            console.log("Items before enriching", items);
            let enrichedOrders = enrichOrders(orders.data);
            setOrders(enrichedOrders);
        }
    }

    const getOrderType = (type) => {
        switch (type) {
            case 0:
                return 'Гостевой';
            case 1:
                return 'Каспи';
            case 2:
                return 'Freedom';
            default:
                return 'N/A';
        }
    }

    const getOrderState = (orderState) => {
        switch (orderState) {
            case 1:
                return 'Активен';
            case 2:
                return 'Продлен';
            case 3:
                return 'Истек';
            case 4:
                return 'Завершен';
            default:
                return 'N/A';
        }
    }

    const handleShowModal = (data) => {
        console.log("Handling show modal", data);
        setShowModal(true);
        setModalData(data);
      };
    
    const handleCloseModal = () => {
        setShowModal(false);
        setModalData({ id: "", sub: "" });
    };

    const handleDelete = () => {
        console.log("Deleting data", modalData);
        const orderId = modalData.id;
        const userSub = modalData.sub;
        setModalData({ id: "", sub: "" });
        setShowModal(false);
        toast.promise(
            new Promise((resolve, reject) => {
                portalService.deleteOrder(orderId, userSub).then((r) => {
                    if (r.data) {
                        const copyOrders = [...orders];
                        const index = copyOrders.findIndex(item => item.id === orderId);
                        if (index !== -1) {
                            // found the updated order
                            const toUpdate = copyOrders[index];
                            toUpdate.bookingState = 3;
                            copyOrders[index] = toUpdate;
                        }
                        setOrders(copyOrders);
                        resolve(null);
                    } else {
                        console.log("Could not delete order");
                        reject(null);
                    }
                }).catch(() => {
                    console.log("Could not delete order");
                    reject(null);
                })
            }),
            {
            pending: 'Отменяем бронь',
            success: 'Бронь отменена 👌',
            error: 'Не удалось отменить бронь 🤯'
        });
        
    }

    const DeleteModal = ({ show, handleClose, handleOk, modalData }) => {
        return (
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Отменить бронь?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Бронь {modalData.id} будет отменена!</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleOk}>
                        Ok
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }

    return (
        <div className="container-fluid">
            <div style={{marginBottom: 20}}>
                {orderTypesGroup()}
            </div>
            <div className='header-tools'>
                <div>
                    <h3 className="mb-4">Брони: {orders.length}</h3>
                </div>
                <div>
                    <Button onClick={onBtnExport} variant="success" size="sm">Экспортировать в Excel <FaFileExcel alignmentBaseline='baseline'/></Button>
                </div>
            </div>
            
            <div className='ag-theme-quartz' style={{height: '75vh'}}>
                {items && Object.keys(items).length != 0 && 
                <AgGridReact
                    pagination={pagination}
                    paginationPageSize={paginationPageSize}
                    paginationPageSizeSelector={paginationPageSizeSelector}
                    postSortRows={postSortRows} 
                    rowData={orders}
                    ref={gridRef}
                    columnDefs={colDefs}
                    defaultColDef={defaultColDef}
                    enableCellTextSelection={true}
                    ensureDomOrder={true}
                    getRowClass={(params) => {
                        return getOrderClass(params.data.severity)
                    }} />
                }
            </div>
            
            <DeleteModal show={showModal} handleClose={handleCloseModal} handleOk={handleDelete} modalData={modalData} />
            <ToastContainer />
            {/* <div>
                <nav aria-label="Page navigation example">
                    <ul className="pagination justify-content-center">
                        <li key='prev-page' className={`page-item ${currentPage == 0 ? "disabled" : ""}`}>
                            <a className="page-link" href="#" tabIndex="-1" onClick={() => setCurrentPage(currentPage-1)}>Предыдущий</a>
                        </li>
                        <Paginator pagesCount={pagesCount} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                        <li key='next-page' className={`page-item ${currentPage == (pagesCount-1) ? "disabled" : ""}`}>
                            <a className="page-link" href="#" onClick={() => setCurrentPage(currentPage+1)}>Следующий</a>
                        </li>
                    </ul>
                </nav>
            </div> */}
        </div>
    );
}

export default Orders;